import $ from 'jquery';

// npm install fitvids --save-dev
import dragscroll from 'dragscroll'

class DragScroll {

}

export default DragScroll;
